import * as PageActionTypes from '../../../constants/contents/PageActionTypes';

const initialState = {
    searchKeyword: '',
    searchType: 'title',
};

export default (state = initialState, action) => {
    switch (action.type) {
        case PageActionTypes.CLEAR_ITEMS:
            return {
                searchKeyword : '',
                searchType : 'title',
            };
        case PageActionTypes.SEARCH_KEYWORD:
            return Object.assign({}, state, {
                searchKeyword: action.searchKeyword,
                searchType: action.searchType,
            });
        default :
            return state;
    }
}
